import type { GridSortModel } from "@mui/x-data-grid-pro";

import type { CellValue, GridRow } from "@/apps/engagement-letter-database/data/types";

import { stringify } from "./stringify";

function compareRowValues(a: CellValue, b: CellValue): number {
  if (a == null && b == null) return 0;
  if (a == null) return -1;
  if (b == null) return 1;
  if (a instanceof Date && b instanceof Date) return a.getTime() - b.getTime();
  if (typeof a === 'number' && typeof b === 'number') return a - b;
  if (typeof a === 'boolean' && typeof b === 'boolean') return Number(a) - Number(b);
  return stringify(a).localeCompare(stringify(b));
}

export function sortRows<T extends GridRow>(rows: T[], sortModel: GridSortModel): T[] {
  const sort = sortModel[0];
  if (!sort?.sort) return rows;
  const { field, sort: direction } = sort;
  const factor = direction === 'desc' ? -1 : 1;
  return [...rows].sort((a, b) => factor * compareRowValues(a[field], b[field]));
}